    <template>
        <v-layout pa-0 fill-height>
            <v-flex xs12>
                <v-card>
                    <v-layout row wrap pa-3 justify-center>
                        <v-flex xs12 md4>
                            <v-list>
                                <v-list-tile class="pa-2"
                                             v-for="settingsCategory in settingsCategories"
                                             :key="settingsCategory.title"
                                             v-model="settingsCategory.active"
                                             avatar
                                             active-class="default-class selected-item"
                                             @click="selectSettingsCategory(settingsCategory)"
                                >
                                    <v-list-tile-avatar>
                                        <v-icon :class="[settingsCategory.iconClass]">{{ settingsCategory.icon }}
                                        </v-icon>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ settingsCategory.title }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ settingsCategory.description }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex xs12 md7>
                            <!-- STARTUP REGISTRATION -->
                            <div v-show="selectedSettingsCategory.id === 'startupRegistration'">
                                <StartupRegistrationHelp></StartupRegistrationHelp>
                            </div>

                            <!-- EDIT STARTUP -->
                            <div v-show="selectedSettingsCategory.id === 'editStartup'">
                                <EditStartupRegistrationHelp></EditStartupRegistrationHelp>
                            </div>


                            <!-- CHALLENGE REGISTRATION -->
                            <div v-show="selectedSettingsCategory.id === 'challengeRegistration'">
                                <ChallengeRegistrationHelp></ChallengeRegistrationHelp>
                            </div>

                            <!-- STARTUP MANAGEMENT -->
                            <div v-show="selectedSettingsCategory.id === 'startupManagement'">
                                <StartupManagementHelp></StartupManagementHelp>
                            </div>

                            <!-- USER MANAGEMENT -->
                            <div v-show="selectedSettingsCategory.id === 'userManagement'">
                                <UserManagementHelp></UserManagementHelp>
                            </div>

                            <!-- GROUP MANAGEMENT -->
                            <div v-show="selectedSettingsCategory.id === 'groupManagement'">
                                <GroupManagementHelp></GroupManagementHelp>
                            </div>

                            <!-- CHALLENGE MANAGEMENT -->
                            <div v-show="selectedSettingsCategory.id === 'challengeManagement'" >
                                <ChallengeManagementHelp></ChallengeManagementHelp>
                            </div>

                            <!-- CHATBOT -->
                            <div v-show="selectedSettingsCategory.id === 'chatbot'">
                                <ChatbotHelp></ChatbotHelp>
                            </div>

                            <!-- STARTUP SEARCH -->
                            <div v-show="selectedSettingsCategory.id === 'startupSearch'">
                                <StartupSearchHelp></StartupSearchHelp>
                            </div>

                            <!-- SYNONYMS -->
                            <div v-show="selectedSettingsCategory.id === 'synonyms'">
                                <SynonymsHelp></SynonymsHelp>
                            </div>

                          <!-- RADAR -->
                          <div v-show="selectedSettingsCategory.id === 'radar'">
                            <RadarHelp></RadarHelp>
                          </div>

                          <!-- TREND MANAGEMENT -->
                          <div v-show="selectedSettingsCategory.id === 'trendManagement'">
                            <TrendManagementHelp></TrendManagementHelp>
                          </div>

                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </template>

    <script>
        import {mapGetters, mapState} from 'vuex';

        import StartupRegistrationHelp from "./StartupRegistrationHelp";
        import EditStartupRegistrationHelp from "./EditStartupRegistrationHelp";
        import ChallengeRegistrationHelp from "./ChallengeRegistrationHelp";
        import StartupManagementHelp from "./StartupManagementHelp";
        import UserManagementHelp from "./UserManagementHelp";
        import GroupManagementHelp from "./GroupManagementHelp";
        import ChallengeManagementHelp from "./ChallengeManagementHelp";
        import Synonyms from "../Innovation/Synonyms/Synonyms";
        import SynonymsHelp from "./SynonymsHelp";
        import ChatbotHelp from "./ChatbotHelp";
        import RadarHelp from  "./RadarHelp";
        import TrendManagementHelp from  "./TrendManagementHelp";
        import StartupSearchHelp from "./StartupSearchHelp";

        export default {
            name: 'Help',
            components: {
                StartupSearchHelp,
                ChatbotHelp,
                SynonymsHelp,
                Synonyms,
                ChallengeManagementHelp,
                GroupManagementHelp,
                UserManagementHelp,
                StartupManagementHelp,
                EditStartupRegistrationHelp,
                StartupRegistrationHelp,
                RadarHelp,
                TrendManagementHelp,
                ChallengeRegistrationHelp},
            props: {
                categoryId: {
                    type: Number, default: 0
                },
                public: {
                    type: Boolean,
                    default: false,
                },
            },
            created() {
                this.selectSettingsCategory(this.settingsCategories[this.categoryId]);
            },
            data() {
                return {
                    selectedSettingsCategory: null,
                    settingsCategoriesAll: {
                        ADMIN: [
                            {
                                id: 'startupRegistration',
                                title: 'Startup Registration',
                                description: 'How to register your startup',
                                icon: 'mdi-briefcase-account',
                                iconClass: 'orange white--text',
                                active: false,
                            },
                            {
                                id: 'editStartup',
                                title: 'Edit Startup',
                                description: 'How to edit your startup information',
                                icon: 'mdi-account-edit',
                                iconClass: 'indigo white--text',
                                active: false,
                            },
                            {
                                id: 'challengeRegistration',
                                title: 'Challenge Registration',
                                description: 'How to submit your proposal to a challenge',
                                icon: 'mdi-flag-outline',
                                iconClass: 'red white--text',
                                active: false,
                            },
                            {
                                id: 'startupManagement',
                                title: 'Startup Management',
                                description: 'How to manage your startup DB',
                                icon: 'mdi-briefcase-account',
                                iconClass: 'green white--text',
                                active: false,
                            },
                            {
                                id: 'userManagement',
                                title: 'User Management',
                                description: 'How to manage Discovery users',
                                icon: 'mdi-account-multiple',
                                iconClass: 'teal white--text',
                                active: false,
                            },
                            {
                                id: 'groupManagement',
                                title: 'Group Management',
                                description: 'How to manage Discovery user groups',
                                icon: 'mdi-group',
                                iconClass: 'amber white--text',
                                active: false,
                            },
                            {
                                id: 'challengeManagement',
                                title: 'Challenge Management',
                                description: 'How to create and publish challenges',
                                icon: 'mdi-flag-outline',
                                iconClass: 'blue white--text',
                                active: false,
                            },
                            {
                                id: 'synonyms',
                                title: 'Synonyms',
                                description: 'How to manage synonyms',
                                icon: 'mdi-alphabetical',
                                iconClass: 'cyan white--text',
                                active: false,
                            },
                            {
                                id: 'startupSearch',
                                title: 'Startup Search',
                                description: 'How to perform advanced search',
                                icon: 'mdi-briefcase-search',
                                iconClass: 'blue-grey white--text',
                                active: false,
                            },
                            {
                                id: 'chatbot',
                                title: 'Chatbot',
                                description: 'How to use chatbot',
                                icon: 'mdi-message',
                                iconClass: 'purple white--text',
                                active: false,
                            },
                          /*{
                            id: 'radar',
                            title: 'Trend Radar',
                            description: 'How to use radar',
                            icon: 'mdi-radar',
                            iconClass: 'green white--text',
                            active: false,
                          },*/
                        ],
                        ADMIN_INNOVATION: [
                            {
                                id: 'startupManagement',
                                title: 'Startup Management',
                                description: 'How to manage your startup DB',
                                icon: 'mdi-briefcase-account',
                                iconClass: 'green white--text',
                                active: false,
                            },
                            {
                                id: 'userManagement',
                                title: 'User Management',
                                description: 'How to manage Discovery users',
                                icon: 'mdi-account-multiple',
                                iconClass: 'teal white--text',
                                active: false,
                            },
                            {
                                id: 'groupManagement',
                                title: 'Group Management',
                                description: 'How to manage Discovery user groups',
                                icon: 'mdi-group',
                                iconClass: 'amber white--text',
                                active: false,
                            },
                            {
                                id: 'challengeManagement',
                                title: 'Challenge Management',
                                description: 'How to create and publish challenges',
                                icon: 'mdi-flag-outline',
                                iconClass: 'blue white--text',
                                active: false,
                            },
                            {
                                id: 'synonyms',
                                title: 'Synonyms',
                                description: 'How to manage synonyms',
                                icon: 'mdi-alphabetical',
                                iconClass: 'cyan white--text',
                                active: false,
                            },
                            {
                                id: 'startupSearch',
                                title: 'Startup Search',
                                description: 'How to perform advanced search',
                                icon: 'mdi-briefcase-search',
                                iconClass: 'blue-grey white--text',
                                active: false,
                            },
                            {
                                id: 'chatbot',
                                title: 'Chatbot',
                                description: 'How to use chatbot',
                                icon: 'mdi-message',
                                iconClass: 'purple white--text',
                                active: false,
                            },
                          /*{
                            id: 'radar',
                            title: 'Trend Radar',
                            description: 'How to use radar',
                            icon: 'mdi-radar',
                            iconClass: 'green white--text',
                            active: false,
                          },*/
                        ],
                        APPROVER_INNOVATION: [
                            {
                                id: 'startupManagement',
                                title: 'Startup Management',
                                description: 'How to manage your startup DB',
                                icon: 'mdi-briefcase-account',
                                iconClass: 'green white--text',
                                active: false,
                            },
                            {
                                id: 'userManagement',
                                title: 'User Management',
                                description: 'How to manage Discovery users',
                                icon: 'mdi-account-multiple',
                                iconClass: 'teal white--text',
                                active: false,
                            },
                            {
                                id: 'groupManagement',
                                title: 'Group Management',
                                description: 'How to manage Discovery user groups',
                                icon: 'mdi-group',
                                iconClass: 'amber white--text',
                                active: false,
                            },
                            {
                                id: 'challengeManagement',
                                title: 'Challenge Management',
                                description: 'How to create and publish challenges',
                                icon: 'mdi-flag-outline',
                                iconClass: 'blue white--text',
                                active: false,
                            },
                            {
                                id: 'synonyms',
                                title: 'Synonyms',
                                description: 'How to manage synonyms',
                                icon: 'mdi-alphabetical',
                                iconClass: 'cyan white--text',
                                active: false,
                            },
                            {
                                id: 'startupSearch',
                                title: 'Startup Search',
                                description: 'How to perform advanced search',
                                icon: 'mdi-briefcase-search',
                                iconClass: 'blue-grey white--text',
                                active: false,
                            },
                            {
                                id: 'chatbot',
                                title: 'Chatbot',
                                description: 'How to use chatbot',
                                icon: 'mdi-message',
                                iconClass: 'purple white--text',
                                active: false,
                            },
                          /*{
                            id: 'radar',
                            title: 'Trend Radar',
                            description: 'How to use radar',
                            icon: 'mdi-radar',
                            iconClass: 'green white--text',
                            active: false,
                          },*/

                          /*{
                            id: 'trendManagement',
                            title: 'Trend Management',
                            description: 'How to manage trend',
                            icon: 'mdi-radar',
                            iconClass: 'red white--text',
                            active: false,
                          },*/
                        ],
  
                      /*RADAR_INNOVATION: [

                        {
                          id: 'radar',
                          title: 'Trend Radar',
                          description: 'How to use radar',
                          icon: 'mdi-radar',
                          iconClass: 'green white--text',
                          active: false,
                        },
                      ],*/
                        USER_INNOVATION: [
                            {
                                id: 'chatbot',
                                title: 'Chatbot',
                                description: 'How to use chatbot',
                                icon: 'mdi-message',
                                iconClass: 'purple white--text',
                                active: false,
                            },
                          /*{
                            id: 'radar',
                            title: 'Trend Radar',
                            description: 'How to use radar',
                            icon: 'mdi-radar',
                            iconClass: 'green white--text',
                            active: false,
                          },*/
                        ],
                        CUSTOMER_CHAT_INNOVATION: [
                            {
                                id: 'chatbot',
                                title: 'Chatbot',
                                description: 'How to use chatbot',
                                icon: 'mdi-message',
                                iconClass: 'purple white--text',
                                active: false,
                            },
                            {
                                id: 'challengeManagement',
                                title: 'Challenge Management',
                                description: 'How to create and publish challenges',
                                icon: 'mdi-flag-outline',
                                iconClass: 'blue white--text',
                                active: false,
                            },
                        ],
                        CUSTOMER_INNOVATION: [
                            {
                                id: 'challengeManagement',
                                title: 'Challenge Management',
                                description: 'How to create and publish challenges',
                                icon: 'mdi-flag-outline',
                                iconClass: 'blue white--text',
                                active: false,
                            },
                        ],
                        STARTUP: [
                            {
                                id: 'startupRegistration',
                                title: 'Startup Registration',
                                description: 'How to register your startup',
                                icon: 'mdi-briefcase-account',
                                iconClass: 'orange white--text',
                                active: false,
                            },
                            {
                                id: 'editStartup',
                                title: 'Edit Startup',
                                description: 'How to edit your startup information',
                                icon: 'mdi-account-edit',
                                iconClass: 'indigo white--text',
                                active: false,
                            },
                            {
                                id: 'challengeRegistration',
                                title: 'Challenge Registration',
                                description: 'How to submit your proposal to a challenge',
                                icon: 'mdi-flag-outline',
                                iconClass: 'red white--text',
                                active: false,
                            },
                        ]
                    }
                }
            },
            computed: {
                ...mapState({}),
                ...mapGetters('UserState', {
                        userInfo: 'getUserInfo',
                    }
                ),
                settingsCategories() {
                    if(this.public || this.userInfo.role === ''){
                        return this.settingsCategoriesAll["STARTUP"];
                    }
                    else return this.settingsCategoriesAll[this.userInfo.role];
                },

            },
            methods: {
                selectSettingsCategory(settingsCategory) {
                    for (let i = 0; i < this.settingsCategories.length; i++) {
                        if (this.settingsCategories[i].id === settingsCategory.id) {
                            this.settingsCategories[i].active = true;
                        } else {
                            this.settingsCategories[i].active = false;
                        }
                    }
                    this.selectedSettingsCategory = settingsCategory;
                },

            }
        }
    </script>

    <style lang="scss">
        .selected-item {
            background-color: rgba(240, 240, 240, 1);
        }
    </style>
